console.log("adaT code loaded");



jQuery('#shopify-section-template--20150649585813__video_with_text_xf7dM8 h5, #shopify-section-template--20150649749653__dynamic_image_with_text_cqGh6m h5').attr('role', 'none');




jQuery("#shopify-section-template--20150649585813__pxs_image_with_text_overlay_h44Gc3 .pxs-image-with-text-background").attr("role","img");
jQuery("#shopify-section-template--20150649585813__pxs_image_with_text_overlay_h44Gc3 .pxs-image-with-text-background").attr("aria-label",'A banner advertisement titled "WINTER TURQUOISE collection" promoting "New Hubei & North American Turquoise.');

jQuery("#shopify-section-template--20150649749653__pxs_image_with_text_overlay_h44Gc3 .pxs-image-with-text-background").attr("role","img");
jQuery("#shopify-section-template--20150649749653__pxs_image_with_text_overlay_h44Gc3 .pxs-image-with-text-background").attr("aria-label",'A vibrant banner ad titled "THE WORLD OF GLASS BEADS" and the subtitle "INSPIRED BY THE GLOBAL ORIGIN OF COLOR & CULTURE."');

jQuery("#shopify-section-template--20150649618581__pxs_image_with_text_overlay_h44Gc3 .pxs-image-with-text-background").attr("role","img");
jQuery("#shopify-section-template--20150649618581__pxs_image_with_text_overlay_h44Gc3 .pxs-image-with-text-background").attr("aria-label",'A banner advertisement titled "Limited Editions" for stones "so scarce they rarely become beads."');

jQuery("#shopify-section-template--20150649618581__dynamic_image_with_text_BXRBb9 h5").attr("role",'none');
jQuery("#shopify-section-template--20150649618581__video_with_text_Ymfjze h5").attr("role",'none');



jQuery('a[href="https://dakotastones.com/pages/shipping"].promo-grid--maintain-aspect-ratio').attr('aria-label', 'Free Shipping Domestic Order Over $50');
jQuery('a[href="https://dakotastones.com/pages/our-guarantee"].promo-grid--maintain-aspect-ratio').attr('aria-label', '100% satisfaction Guaranteed');
jQuery('a[href="https://dakotastones.com/pages/wholesale"].promo-grid--maintain-aspect-ratio').attr('aria-label', 'More Information about Wholesale');
jQuery('a[href="https://dakotastones.com/pages/dakota-stones-difference"].promo-grid--maintain-aspect-ratio').attr('aria-label', 'dakota stones difference');
jQuery('a[href="https://dakotastones.com/pages/ethically-sourced-gemstones"].promo-grid--maintain-aspect-ratio').attr('aria-label', 'ethically sourced gemstones');
jQuery('a[href="/pages/live-sales"].promo-block--content-align-top-left').attr('aria-label', 'live sales');



jQuery(".slideshow-pagination__button").attr("role","tab");
jQuery("slideshow-slide.slideshow-slide--mobile.pxu-lia-block").attr("role","tabpanel");
jQuery('button[data-slide-button="0"]').attr('aria-controls', 'slide-0');
jQuery('button[data-slide-button="1"]').attr('aria-controls', 'slide-1');
jQuery('button[data-slide-button="2"]').attr('aria-controls', 'slide-2');
jQuery('button[data-slide-button="3"]').attr('aria-controls', 'slide-3');

jQuery('div[data-slide-index="0"]').attr('id', 'slide-0');
jQuery('div[data-slide-index="1"]').attr('id', 'slide-1');
jQuery('div[data-slide-index="2"]').attr('id', 'slide-2');
jQuery('div[data-slide-index="3"]').attr('id', 'slide-3');

jQuery('div[data-slide-index="0"] img:eq(0)').attr('alt', 'WINTER TURQUOISE collection New Hubei & North American Turquoise');
jQuery('div[data-slide-index="1"] img:eq(0)').attr('alt', 'Gift Card Offer: Use code FREE25 at checkout when you purchase a $125 gift card, YOU PAY ONLY $100! Click this banner for more details.');
jQuery('div[data-slide-index="2"] img:eq(0)').attr('alt', 'Pearls, Pearls, Pearls! Text over left image: White Oval Coin Text over right image: Peacock Potato');
jQuery('div[data-slide-index="3"] img:eq(0)').attr('alt', 'ds dakotastones TOOLS & SUPPLIES We are more than just high quality gemstones! SHOP Now');

jQuery('div[data-slide-index="0"] a:eq(0)').attr('aria-label', 'WINTER TURQUOISE collection New Hubei & North American Turquoise');
jQuery('div[data-slide-index="1"] a:eq(0)').attr('aria-label', 'Gift Card Offer: Use code FREE25 at checkout when you purchase a $125 gift card, YOU PAY ONLY $100! Click this banner for more details.');
jQuery('div[data-slide-index="2"] a:eq(0)').attr('aria-label', 'Pearls, Pearls, Pearls! Text over left image: White Oval Coin Text over right image: Peacock Potato');
jQuery('div[data-slide-index="3"] a:eq(0)').attr('aria-label', 'ds dakotastones TOOLS & SUPPLIES We are more than just high quality gemstones! SHOP Now');

jQuery('.slideshow-slide__content--slide-3 a').attr('aria-label', 'WINTER TURQUOISE collection New Hubei & North American Turquoise');
jQuery('.slideshow-slide__content--slide-2 a').attr('aria-label', 'Gift Card Offer: Use code FREE25 at checkout when you purchase a $125 gift card, YOU PAY ONLY $100! Click this banner for more details.');
jQuery('.slideshow-slide__content--slide-1 a').attr('aria-label', 'Pearls, Pearls, Pearls! Text over left image: White Oval Coin Text over right image: Peacock Potato');
jQuery('.slideshow-slide__content--slide-4 a').attr('aria-label', 'ds dakotastones TOOLS & SUPPLIES We are more than just high quality gemstones! SHOP Now');


jQuery(".productgrid--sidebar-item-swatches-grid div:eq(0)").attr("role","list");
jQuery(".productgrid--sidebar-item-swatches-grid li").attr("role","listitem");

jQuery("svg").attr("aria-hidden","true");





jQuery(".productitem--title, .article--excerpt-title").attr("aria-level","3");

jQuery('.button-primary.featured-collection__button.mdc-ripple-surface.mdc-ripple-upgraded')
        .attr('aria-label', 'view all homepage specials gemstone beads');

jQuery(".blogposts--footer-link").attr("aria-label","See More Blogs posts, opens Blog page");
jQuery("br").attr("aria-hidden","true");
jQuery('a[href="https://www.facebook.com/dakotastones"]').attr('aria-label', 'Facebook, opens Facebook page in new tab');
jQuery('a[href="https://www.instagram.com/dakotastones/"]').attr('aria-label', 'instagram, opens instagram page in new tab');
jQuery('a[href="https://www.pinterest.com/dakotastones/"]').attr('aria-label', 'pinterest, opens pinterest page in new tab');
jQuery('a[href="https://www.youtube.com/channel/UCMGD3ydRKInWDFE7F2f3kBA"]').attr('aria-label', 'youtube, opens youtube page in new tab');

jQuery('.share-buttons--facebook').attr('aria-label', 'Share this article on facebook, opens new in tab');
jQuery('.share-buttons--x').attr('aria-label', 'Share this article on X, opens new in tab');
jQuery('.share-buttons--linkedin').attr('aria-label', 'Share this article on linkedin, opens new in tab');
jQuery('.share-buttons--pinterest').attr('aria-label', 'Share this article on pinterest, opens new in tab');


jQuery(".site-footer-credits a").attr("aria-label","Powered By Shopify, opens Shopify website in a new tab");
jQuery(".atc-subtotal--label").attr("role","heading");
jQuery(".atc-subtotal--label").attr("aria-level","2");

jQuery(".atc-banner--container").attr("aria-label","Cart dialog box");
jQuery('a:contains("Ask a question!")').attr('aria-label', 'Ask a question!, opens email application');
jQuery(".product-block--title.product-block--first h1, .page-title, .article--title").attr("aria-level","2");
jQuery(".product-section--content.product-row h2").attr("aria-level","3");

jQuery(".search-flydown--product.search-flydown--product").attr("aria-label","product search flydown");

jQuery('a[href="https://tucsongemshow101.com/glw-gemmall-holidome"]').attr('aria-label', 'More information about G&LW Gem Mall and Holidome, opens in new tab');
jQuery('a[href="http://artglassandbeadshow.com/"]').attr('aria-label', 'More information about Madison Art and Glass, opens in new tab');
jQuery('a[href="https://wholebead.com/"]').attr('aria-label', 'More information about Whole Bead Show Milwaukee, opens in new tab');
jQuery('a[href="https://www.makerfestivals.com/pa/4709711"]').attr('aria-label', 'More information about Bead Fest, opens in new tab');
jQuery('a[href="https://twincitiesbeadbazaar.com/"]').attr('aria-label', 'More information about Twin Cities Bead Bazaar, opens in new tab');
jQuery('a[href="https://glwshows.com/shows/042024-minneapolis-mn/"]').attr('aria-label', 'More information about glw shows, opens in new tab');


//jQuery('a:contains("G&LW Minneapolis")').attr('aria-label', 'More information about G&LW Minneapolis, opens in new tab');
//jQuery('a:contains("Milwaukee Mineral, Fossil, Crystal, Gem, & Jewelry Show")').attr('aria-label', 'More information about Milwaukee Mineral, Fossil, Crystal, Gem, & Jewelry Show, opens in new tab');
//jQuery('a:contains("Milwaukee Mineral, Fossil, Crystal, Gem, & Jewelry Show")').attr('aria-label', 'More information about Milwaukee Mineral, Fossil, Crystal, Gem, & Jewelry Show, opens in new tab');

jQuery(document).ready(function(){ 
    setTimeout(function(){ 
      jQuery("br").attr("aria-hidden","true");
      jQuery("hr").attr("aria-hidden","true");
      jQuery(".product-section--content.product-row h2").attr("aria-level","3");
      jQuery(".flickity-viewport h2").attr("aria-level","3");
        jQuery('.slideshow-slide__content--slide-3 a').attr('aria-label', 'WINTER TURQUOISE collection New Hubei & North American Turquoise');
        jQuery('.slideshow-slide__content--slide-1 a').attr('aria-label', 'Gift Card Offer: Use code FREE25 at checkout when you purchase a $125 gift card, YOU PAY ONLY $100! Click this banner for more details.');
        jQuery('.slideshow-slide__content--slide-2 a').attr('aria-label', 'Pearls, Pearls, Pearls! Text over left image: White Oval Coin Text over right image: Peacock Potato');
        jQuery('.slideshow-slide__content--slide-4 a').attr('aria-label', 'ds dakotastones TOOLS & SUPPLIES We are more than just high quality gemstones! SHOP Now');
      
        jQuery('a[aria-disabled="true"]').attr('tabindex', '-1');



 


      
     },
  3000); 

});        

jQuery(function() {
    // Get the page title
    var pageTitle = jQuery('title').text().trim();

    // Create a visually hidden H1
    var hiddenH1 = jQuery('<h1>', {
        text: pageTitle,
        css: {
            position: 'absolute',
            left: '-9999px',
            top: 'auto',
            width: '1px',
            height: '1px',
            overflow: 'hidden'
        }
    });

    // Prepend the H1 inside #site-main as the first child
    jQuery('#site-main').prepend(hiddenH1);
});

jQuery(function($){

    $('.article--excerpt-content').each(function(){

        // Get the article title from the H2
        let titleText = $(this).find('.article--excerpt-title').text().trim();

        // Target the "Read now" link
        let $readMore = $(this).find('.article--excerpt-readmore');

        if (titleText && $readMore.length) {
            // Create descriptive aria-label
            let finalLabel = "Read article: " + titleText;

            // Apply aria-label if not already present
            if (!$readMore.attr('aria-label')) {
                $readMore.attr('aria-label', finalLabel);
            }
        }

    });

});

jQuery(function($){

    setTimeout(function() {

        $('.atc-subtotal--price.money').each(function(){
            let subtotal = $(this).text().trim(); // "$40.00"
            $(this).attr('aria-label', 'subtotal ' + subtotal);
        });

    }, 3000); // 3000ms = 3 seconds

});

jQuery(function($){
    $('.button-primary.featured-collection__button.mdc-ripple-surface.mdc-ripple-upgraded').each(function(){
        var $link = $(this);
        var href = $link.attr('href'); // e.g., "/collections/january-gemstone-beads"

        if (href) {
            // Get the first part after "/collections/"
            var parts = href.split('/');
            var collectionSlug = parts.pop() || parts.pop(); // last non-empty part

            // Extract the month (assuming it's the first word in slug)
            var month = collectionSlug.split('-')[0]; // "january"

            // Capitalize the first letter
            month = month.charAt(0).toUpperCase() + month.slice(1);

            // Set aria-label
            $link.attr('aria-label', 'Shop collection ' + month);
        }
    });
});





// $(document).ready(function () {
//     $('h3.atc--product-details--title').each(function () {
//         if ($(this).text().trim() === '') {
//             $(this).remove();
//         }
//     });
// });

$(document).ready(function() {
    $('.slideshow-slide__content-background-link').each(function() {
        var url = $(this).attr('href'); // "/pages/gray-thursday"
        if (url) {
            // Get last part of URL and convert hyphens to spaces
            var slug = url.split('/').filter(Boolean).pop().replace(/-/g, ' ');
            $(this).attr('aria-label', slug); // Add aria-label
        }
    });
});

jQuery('.filter-item--swatch-wrapper').each(function () {
    const colorName = jQuery(this).data('swatch-tooltip');

    jQuery(this)
      .closest('a')
      .attr('aria-label', colorName)
      .attr('data-tooltip', colorName); // (optional) used for CSS tooltip
});





jQuery(document).ready(function () {
  jQuery('.productitem__container').each(function () {
    const productName = jQuery(this).find('.productitem--title').text().trim();

    jQuery(this).find('img').each(function () {
      jQuery(this).attr('alt', productName);
    });
  });
});


jQuery(document).ready(function () {

  // 1. Inject the Play/Pause button after each video
  jQuery(".image-with-text__video").each(function () {
    const video = jQuery(this);
    const btn = jQuery('<button class="video-toggle" aria-label="Pause video">Pause</button>');
    video.after(btn);


    // 2. Toggle Play/Pause
    const vid = video.get(0);

    btn.on("click", function () {
      if (vid.paused) {
        vid.play();
        btn.text("Pause");
        btn.attr("aria-label", "Pause video");
      } else {
        vid.pause();
        btn.text("Play");
        btn.attr("aria-label", "Play video");
      }
    });
  });

});
